import Layout from "../../../Layout/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../css/weekly-war-map.css";
import WarmapContainer from "./components/WarmapContainer";

const WeeklyWarmap = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const weeklyWarmapsQuestionsFromState =
    location.state?.weeklyWarmapsQuestions || null;

  return (
    <Layout>
      <div className="page-content">
        <div className="assessment-content goals-main">
          <div className="d-flex gap-4 mb-3 mb-md-4 align-items-center">
            <button
              id="prevButton"
              className="btn d-flex justify-content-center align-items-center rounded-circle"
              onClick={() => navigate(-1)}
              style={{
                width: "40px",
                height: "40px",
              }}
            >
              <img src="/icons/back-arrow.svg" alt="" />
            </button>
            <h1 className="text-heading-h2 mb-0" style={{ color: "#e6ecf1" }}>
              Weekly Warmaps
            </h1>
          </div>
          <div className="weekly-war-map-container">
            <WarmapContainer
              initialWeeklyWarmapsQuestions={weeklyWarmapsQuestionsFromState}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WeeklyWarmap;
